define('modules/editor/views/elements/area',['require','exports','module','base/collectionview','../../models/editorstate','lib/util','../element_view_factory','ldsh!../../templates/elements/area','../../behaviours/draggable','../../behaviours/selectable','../../behaviours/movable','../../behaviours/render_with_property_groups','../../behaviours/hoverable','../../behaviours/alignable','../../behaviours/droppable'],function(require, exports, module){
  "use strict";

  var CollectionView = require("base/collectionview"),
      EditorState = require("../../models/editorstate"),
      GroupState = EditorState.groupState,
      util = require("lib/util");

  module.exports = CollectionView.extend({
    initialize: function(options) {
      this.data = options.parent.data;
      this.collection = this.model.elements;
      this.listenTo(this.model, "change", this.render);
    },
    itemView: require("../element_view_factory"),
    itemContainer: ".js-area-elements",
    template: require("ldsh!../../templates/elements/area"),
    className: "ed-panel-item ed-item-area",
    onAddChildView: function(){
      if (!EditorState.isGenerateMode()) {
        GroupState.replaceViewWith.apply(GroupState, arguments);
      }
    },
    getDelta: function() {
      var offset = this.$el.offset(),
          pageOffset = this.$el.parents(".lpg-page").offset();
      return {
        top: offset.top - pageOffset.top,
        left: offset.left - pageOffset.left
      };
    },
  });
  
  util.mixin(module.exports, require("../../behaviours/draggable"));
  util.mixin(module.exports, require("../../behaviours/selectable"));
  util.mixin(module.exports, require("../../behaviours/movable"));
  util.mixin(module.exports, require("../../behaviours/render_with_property_groups"));
  util.mixin(module.exports, require("../../behaviours/hoverable"));
  util.mixin(module.exports, require("../../behaviours/alignable"));
  util.mixin(module.exports, require("../../behaviours/droppable"));
});

